<template>
    <div>
      <v-dialog/>
      <div class="class_add_top">
        <a class="back" onclick="history.go(-1)">
          返回
        </a>
        <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>证书模板
        <div style="position: absolute; top: 0; right: 0; width: 150px; height: 46px;">
          <div class="cert_add" style="position: relative; right: -14px;" v-if="!isEdit">
            <UploadOSS :uploadOSSConf="uploadOSSConf" v-if="uploadOSSConf.STS!=null" @success = "OSSUploadSuccess" @getFile="preview">
            </UploadOSS>
          </div>
        </div>
      </div>
      <div class="class_add_con">
        <div v-if="loaded">
          模板名称: <input type="text" v-model="form.name">
          宽度(像素): <input type="text" v-model="displayW">
          高度(像素): <input type="text" v-model="displayH">
          <!--字体(像素): <input type="text" readonly v-model="labelFontSize"-->
        </div>
        <div id="cert_model">
          <div v-if="!isEdit" class="certificate_top_con" :style="{height: displayH + 'px'}">
            <div v-if="!loaded && !isEdit" style="padding-top: 100px;">证书显示区域</div>
            <img :src="localSrc" :width="displayW" :height="displayH" style="vertical-align: top;"><!-- gap
          --><canvas v-if="displayW > 471" id="canvas" :width="canvasW" :height="canvasH" :style="{marginTop: (-canvasH) + 'px'}" class="canvas"></canvas><!--
          --><canvas v-if="displayW <= 471" id="canvas" :width="canvasW" :height="canvasH" :style="{marginLeft: (-canvasW) + 'px'}" class="canvas"></canvas>
            <div class="submitContainer" v-debounce-click @click="submit">
              <div class="submitbox">
                提交
              </div>
            </div>
          </div>
          <div v-if="isEdit" class="certificate_top_con" :style="{height: displayH + 'px'}" style="position: relative;">
            <img id="pic" :src="form.url" :width="displayW" :height="displayH" style="vertical-align: top;"><!-- gap
          --><canvas v-if="displayW > 471" id="canvas" :width="canvasW" :height="canvasH" :style="{marginTop: (-canvasH) + 'px'}" class="canvas"></canvas><!--
          --><canvas v-if="displayW <= 471" id="canvas" :width="canvasW" :height="canvasH" :style="{marginLeft: (-canvasW) + 'px'}" class="canvas"></canvas>
            <div style="position: relative;" :style="{top: -displayH - 20 + 'px', left: (((942 - displayW) > 0) ? (942 - displayW)/2 : 0) + 'px'}">
              <label v-for="item in labels" :key="item.pointKey" :data-key="item.pointKey" :data-value="item.pointValue" :data-label="item.pointLabel" :style="{ left: item.localX + 'px', top: (item.localY - tagHeight) + 'px', 'font-size': labelFontSize + 'px' }" class="drag" style="position: absolute;">
                {{item.pointLabel}}
              </label>
            </div>
            <div class="submitContainer" v-debounce-click @click="submit">
              <div class="submitbox">
                提交
              </div>
            </div>
          </div>
          <table width="100%" border="0" cellspacing="0" cellpadding="0" class="mt20">
            <tr class="tita">
              <td class="left_td">证书标签信息</td>
              <td>&nbsp;</td>
            </tr>
          </table>
          <div class="certificate_con_dd" style="padding-left: 20px; padding-top: 5px;">
            <dl>
              * 拖动下列标签到证书模板中
            </dl>
            <img src="@/assets/images/certnotes.png" alt="">
          </div>
          <div>
            <div style="position: relative; padding-left: 15px;" v-if="isEdit">
              <label v-for="item in llabels" :style="{ 'font-size': labelFontSize + 'px' }" :key="item.pointKey" :data-key="item.pointKey" :data-value="item.pointValue" :data-label="item.pointLabel" class="drag">
                {{item.pointLabel}}
              </label>
            </div>
            <div style="position: relative; padding-left: 15px;" v-if="!isEdit">
              <!--div v-for="(item, idx) in labels" :key="item.pointKey" :data-key="item.pointKey" :data-value="item.pointValue" :data-label="item.pointLabel" :style="{left: 65 * idx + 'px'}" v-drag class="drag">
                {{item.pointLabel}}
              </div-->
              <div v-for="item in labels" :style="{ 'font-size': labelFontSize + 'px' }" :key="item.pointKey" :data-key="item.pointKey" :data-value="item.pointValue" :data-label="item.pointLabel" class="drag">
                {{item.pointLabel}}
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="mt20">
          <tr class="tita">
            <td class="left_td">证书标签样式</td>
            <td>&nbsp;</td>
          </tr>
        </table>
        <div class="mt20">
          <table width="900" border="0" cellspacing="1" cellpadding="0" class="px_content" >
            <thead>
              <tr>
                <td width="60">名称</td>
                <td width="60">字号</td>
                <td width="70">字体</td>
                <td width="220">颜色</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in oldLabels">
                <td>
                  <span :style="{fontSize: item.certFont.size + 'px', fontFamily: item.certFont.fontName, color: getColor(item.certFont.colors) }">{{item.pointLabel}}</span>
                </td>
                <td>
                  <input type="text" style="width: 60px;" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" v-model="item.certFont.size">
                </td>
                <td>
                  <select v-model="item.certFont.fontName">
                    <option value="Microsoft YaHei">微软雅黑</option>
                    <option value="SimHei">黑体</option>
                    <option value="SimSun">宋体</option>
                  </select>
                </td>
                <td style="padding: 10px;">
                  <!--slider-picker v-model="item.certFont.colors" /-->
                  <compact-picker v-model="item.certFont.colors"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="mt20">
          <tr class="tita">
            <td class="left_td">证书发放信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt30"></td>
            <td class="pt20">
              <input name="time" type="radio" value="0" v-model="dateExpiringType"/>
              按到期日　　
              <input name="time" type="radio" value="1" v-model="dateExpiringType"/>
              按有效期(天)
            </td>
          </tr>
          <tr v-show="dateExpiringType == '0'">
            <td class="left_td pt30">到期日：</td>
            <td class="pt20">
              <!--input type="text" v-model="form.expiringDate" id="J-xl" placeholder="选择证书到期日" class="put_495" style="width: 180px;" /-->
              <el-date-picker
                v-model="form.expiringDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择证书到期日" width="180px">
              </el-date-picker>
            </td>
          </tr>
          <tr v-show="dateExpiringType == '1'">
            <td class="left_td pt30">有效期：</td>
            <td class="pt20">
              <input type="text" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" v-model="form.termOfValidity" class="put_495" style="width: 180px;"/>&nbsp;&nbsp;天
            </td>
          </tr>
        </table>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="mt20">
          <tr class="tita">
            <td class="left_td" style="padding-left: 25px;">证书编号规则</td>
            <td>
              <select style="display: inline-block;" class="all_select" v-model="codeRuleObj">
                <option value="fixed">固定值</option>
                <option value="separator">分隔符</option>
                <option value="serial_number">序列号</option>
                <option value="date">日期</option>
              </select>
              <div class="all_btn" @click="addRow(codeRuleObj)" style="display: inline-block;">+ 字段</div>
              编号预览: {{previewCodeStr}}
            </td>
          </tr>
        </table>
        <div style="padding: 15px 25px;">
          <div v-if="codeRule.length > 0" v-for="(item,idx) in codeRule" :key="item.id" style="padding-bottom: 15px; display: inline-block;">
            <span>{{idx+1}}</span>
            <div v-if="item.type == 'fixed'" style="display: inline-block;">
              <input type="text" placeholder="任意字符" v-model="item.value" class="put_100">&nbsp;&nbsp;
              <a title="删除" @click="delRow(idx)" class="el-icon-remove" style="cursor: pointer;"></a>
            </div>&nbsp;
            <div v-if="item.type == 'separator'" style="display: inline-block;">
              <select class="all_select" v-model="item.value">
                <option value="-">-</option>
                <option value="/">/</option>
              </select>&nbsp;&nbsp;
              <a title="删除" @click="delRow(idx)" class="el-icon-remove" style="cursor: pointer;"></a>
            </div>&nbsp;
            <div v-if="item.type == 'serial_number'" style="display: inline-block;">
              <input type="text" placeholder="多少位序列号" v-model="item.value" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" class="put_100">&nbsp;&nbsp;
              <a title="删除" @click="delRow(idx)" class="el-icon-remove" style="cursor: pointer;"></a>
            </div>&nbsp;
            <div v-if="item.type == 'date'" style="display: inline-block;">
              <select class="all_select" v-model="item.value">
                <option value="yyyy">年(4位)</option>
                <option value="yy">年(2位)</option>
                <option value="yyyyMM">年月</option>
                <option value="yyyyMMdd">年月日</option>
              </select>&nbsp;&nbsp;
              <a title="删除" @click="delRow(idx)" class="el-icon-remove" style="cursor: pointer;"></a>
            </div>&nbsp;
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'

  import diffenence from 'lodash.differenceby'
  import utils from '@/utils'
  import clonedeep from 'lodash.clonedeep'
  import isempty from 'lodash.isempty'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import { Slider, Compact } from 'vue-color'
  export default {
    data () {
      return {
        tagHeight: 26,
        labelFontSize: 18,
        ratio: 0, // 图片实际长宽比
        actualW: 0,
        actualH: 0,
        displayW: 0,
        displayH: 0,
        loaded: false,
        localSrc: '',
        dateExpiringType: '0',
        codeRule: [],
        form: {
          certTemplatePointLoactionList: [],
          url: '',
          width: '',
          height: '',
          codeRule: [], // 自定义证书编号规则
          expiringDate: '', // 到期日(时分秒)
          termOfValidity: '' // 有效期
        },
        codeRuleObj: 'fixed',
        labels: [{
          pointKey: 'user_name',
          pointValue: '姓名',
          pointLabel: '姓名'
        }, {
          pointKey: 'dep_name',
          pointValue: '公司/部门',
          pointLabel: '公司/部门'
        }, {
          pointKey: 'position',
          pointValue: '职位',
          pointLabel: '职位'
        }, {
          pointKey: 'user_idCardNo',
          pointValue: '身份证号',
          pointLabel: '身份证号'
        }, {
          pointKey: 'cert_code',
          pointValue: '证书编号',
          pointLabel: '证书编号'
        }, {
          pointKey: 'userplan_result',
          pointValue: '结果',
          pointLabel: '结果'
        },  {
          pointKey: 'userplan_achievement',
          pointValue: '学分/学时',
          pointLabel: '学分/学时'
        }, {
          pointKey: 'plan_title',
          pointValue: '计划名称',
          pointLabel: '计划名称'
        },  {
          pointKey: 'plan_beginDate',
          pointValue: '计划开始日期',
          pointLabel: '计划开始日期'
        },  {
          pointKey: 'plan_endDate',
          pointValue: '计划结束日期',
          pointLabel: '计划结束日期'
        },  {
          pointKey: 'cert_date',
          pointValue: '证书日期',
          pointLabel: '证书日期'
        }, {
          pointKey: 'qrCodeUrl_1',
          pointValue: '二维码1',
          pointLabel: '二维码1'
        }, {
          pointKey: 'qrCodeUrl_2',
          pointValue: '二维码2',
          pointLabel: '二维码2'
        }],
        prefix: this.$route.meta.prefix || '',
        oldLabels: [],
        llabels: [], // 编辑状态时剩余的标签
        previewCodeStr: '',
        uploadOSSConf: { showMode: '2', style: 'cert_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    components: { UploadOSS, 'slider-picker': Slider,  'compact-picker': Compact,},
    watch: {
      'codeRule': {
        handler(val) {
          if (val) {
            this.previewCode(val)
          }
        },
        deep: true
      }
    },
    mounted () {
      this.getSTS()
      this.OSSUploadSuccess()
      this.initLayDate()
      if (this.isEdit) { // 通过 id 取信息
        this.loaded = true;
        this.getModel(this.$route.params.id);
        this.$on('data-prepared', function (data) {
          let oldLabels = this.labels
          this.displayW = data.width;
          this.displayH = data.height;
          this.labels = data.certTemplatePointLoactionList;
          this.llabels = diffenence(oldLabels, data.certTemplatePointLoactionList, 'pointKey') // 编辑状态下剩余的标签
          if (data.codeRule) {
            this.codeRule = JSON.parse(data.codeRule).codeRule
            let serial_numbers = this.codeRule.filter((o) => {
              return o.type == 'serial_number'
            })
            serial_numbers.forEach((o) => { // 将位数转为“00001”这种格式显示
              o.value = o.value.length
            })
          }
          if (data.termOfValidity) {
            this.dateExpiringType = '1'
          }
          this.oldLabels = this.getCertFont(oldLabels, data.certTemplatePointLoactionList)
          /* if (data.expiringDate) {
            data.expiringDate = utils.dateFormat(new Date(data.expiringDate), 'yyyy-MM-dd')
          } */
        });
      } else {
        this.oldLabels = clonedeep(this.labels)
        this.oldLabels.forEach((o) => {
          this.$set(o,'certFont',{
            fontName: 'Microsoft YaHei',
            size: '18',
            colors: {
              rgba: {
                r: 0,
                g: 0,
                b: 0,
                a: 1
              }
            }
          })
        })
      }
      this.getCords();
    },
    destroyed () {
      $('#cert_model').off('mousedown') // 销毁时要解除绑定
      document.onmousemove = null;
      document.onmouseup = null;
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      },
      canvasW: {
        get: function () {
          return this.displayW || this.displayH * this.ratio
        },
        set: function (newValue) {
          //
        }
        // return this.displayW || this.displayH * this.ratio || this.actualW
      },
      canvasH () {
        return this.displayH || this.displayW / this.ratio
      }
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      getCords () {
        var oldX, oldY, newX, newY;
        var drags = $('.drag');
        var canvas = document.getElementById("canvas");
        var self = this;
        $('#cert_model').off('mousedown').on('mousedown', drags, function (ev) { // 这里绑定事件的写法为了兼顾到动态生成的".drag"dom
          ev.stopPropagation()
          var $drag = $(ev.target);
          var cord;
          var _r = function () { // 标签移出画布后要更新保存的数组
            if ($drag.attr('data-key')) {
              var index = utils.findElem(self.form.certTemplatePointLoactionList, 'pointKey', $drag.attr('data-key'));
              if (index > -1) {
                var o = self.form.certTemplatePointLoactionList[index]
                utils.removeObjWithArr(self.form.certTemplatePointLoactionList, o)
                self.llabels.push(o)
              }
            }
          }
          $drag.css('position', 'relative'); // 元素相对定位
          if (!$drag.get(0).style.left && !$drag.get(0).style.top) { // 第一次设置left、top为0
            $drag.css('left', '0px')
            $drag.css('top', '0px')
          }
          oldX = ev.clientX; // 记录初始光标相对于视窗坐标
          oldY = ev.clientY;
          document.onmousemove = function (ev) {
            var oevent = ev || event;
            newX = oevent.clientX; // 获取当前新光标相对于视窗坐标
            newY = oevent.clientY;
            $drag.css('left', parseInt($drag.get(0).style.left) + newX - oldX + 'px'); // 更新
            $drag.css('top', parseInt($drag.get(0).style.top) + newY - oldY + 'px'); // 更新
            oldX = newX; // 新坐标变为老坐标
            oldY = newY;
            cord = self.getCanvasPos(canvas, oevent);
          };
          document.onmouseup = function () {
            if (cord) {
              if (Math.floor(cord.x) > self.canvasW || Math.floor(cord.x) < 0) {
                // self.$toasted.show('请将标签移入模板内部以确保证书显示正确')
                _r()
              } else if (Math.floor(cord.y) > self.canvasH || Math.floor(cord.y) < 0) {
                // self.$toasted.show('请将标签移入模板内部以确保证书显示正确')
                _r()
              } else {
                var dragOffsetX = $drag.offset().left - $('#canvas').offset().left;
                var dragOffsetY = $drag.offset().top - $('#canvas').offset().top;
                var r = {};
                r.pointKey = $drag.attr('data-key');
                r.pointValue = $drag.attr('data-value');
                r.pointLabel = $drag.attr('data-label');
                // r.localX = cord.x; // 不准确
                // r.localY = cord.y;
                r.localX = dragOffsetX;
                r.localY = dragOffsetY + self.tagHeight; // 要加上标签的高度
                if (r.pointKey) {
                  var index = utils.findElem(self.form.certTemplatePointLoactionList, 'pointKey', r.pointKey); // 找到保存数组里的标签
                  var lindex = utils.findElem(self.llabels, 'pointKey', r.pointKey); // 找到剩余标签
                  if (index == '-1') {
                    self.form.certTemplatePointLoactionList.push(r);
                    utils.removeObjWithArr(self.llabels, self.llabels[lindex])
                  } else {
                    self.form.certTemplatePointLoactionList[index] = r;
                    utils.removeObjWithArr(self.llabels, self.llabels[lindex])
                  }
                }
              }
            }
            document.onmousemove = null;
            document.onmouseup = null;
          };
        });
      },
      getStyles (obj) { // 兼容FF，IE10; IE9及以下未测试
        return document.defaultView.getComputedStyle(obj);
      },
      getCanvasPos (canvas, e) { // 获取鼠标在canvas上的坐标
        var rect = canvas.getBoundingClientRect();
        var leftB = parseInt(this.getStyles(canvas).borderLeftWidth); // 获取的是样式，需要转换为数值
        var topB = parseInt(this.getStyles(canvas).borderTopWidth);
        var cords = {
          x: (e.clientX - rect.left) - leftB,
          y: (e.clientY - rect.top) - topB
        };
        return cords;
      },
      submit () {
        var bus = this;
        this.form.width = this.displayW;
        this.form.height = this.displayH;
        if (this.form.url) {
          if (this.form.name) {
            if (this.form.certTemplatePointLoactionList.length == '0') {
              bus.$toasted.show('请至少选择一个模板标签')
            } else {
              if (bus.codeRule) {
                let all = bus.createCodeRule(bus.codeRule)
                if (all.length > 0) {
                  bus.form.codeRule = JSON.stringify({ codeRule: all })
                } else {
                  bus.form.codeRule = []
                }
              }
              bus.setCertFont(bus.form.certTemplatePointLoactionList, bus.oldLabels)
              if (bus.dateExpiringType == '0') {
                if (bus.form.termOfValidity) {
                  delete bus.form.termOfValidity
                }
              } else {
                if (bus.form.expiringDate) {
                  delete bus.form.expiringDate
                }
              }
              if (bus.form.expiringDate || bus.form.termOfValidity) {
                // console.log(bus.form.codeRule)
                if (utils.isArray(bus.form.codeRule) && bus.form.codeRule.length == 0) {
                  bus.$toasted.show('请设置证书编号规则，发证必填')
                } else {
                  if (this.isEdit) { // 编辑
                    bus.confirmBox({
                      yes: function () {
                        api.post(config.certApiPath, '/cert-templates/modify/' + bus.form.id, bus.form, function (r) { // 正常
                          bus.$toasted.show('保存成功')
                          bus.$router.push(bus.prefix + '/org/certList')
                        }, function (err) {
                          bus.$toasted.show(err)
                        })
                      }
                    })
                  } else { // 新增
                    bus.confirmBox({
                      yes: function () {
                        api.post(config.certApiPath, '/cert-templates', bus.form, function (r) { // 正常
                          bus.$toasted.show('创建证书模板成功')
                          bus.$router.push(bus.prefix + '/org/certList')
                        }, function (err) {
                          bus.$toasted.show(err)
                        })
                      }
                    })
                  }
                }
              } else {
                bus.$toasted.show('请设置证书到期日或者证书有效期')
              }
              // console.log(bus.form)
            }
          } else {
            bus.$toasted.show('请填写模板名称')
          }
        } else {
          this.$toasted.show('请上传模板!')
        }
      },
      preview (file) {
        var self = this
        // var pic = document.getElementById('pic')
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          var image = new Image();
          var data = e.target.result;
          image.src = data;
          image.onload = function () {
            var w = image.width;
            var h = image.height;
            var ratio = w / h;
            self.actualW = w;
            self.actualH = h;
            self.ratio = ratio;
            self.displayH = Math.floor(h);
            self.displayW = Math.floor(ratio * self.displayH);
          }
          // pic.src = data;
          self.localSrc= data;
          self.loaded = true;
        }
      },
      OSSUploadSuccess (r) {
        if (r) {
          this.form.url = r.res.requestUrls[0]
        }
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      },
      initLayDate () {
        var self = this
        var startTime = laydate.render({
          elem: '#J-xl',
          done: function (value, date) {
            self.form.expiringDate = value;
          }
        });
      },
      getModel (id) {
        var that = this
        api.get(config.certApiPath, '/cert-templates/'+id, null, function (r) { // 正常
          that.form = r.data
          that.$emit('data-prepared', that.form)
        })
      },
      hasSerials (arr) {
        return utils.findElem(arr, 'type', 'serial_number') > -1
      },
      addRow (t) {
        if (t == 'serial_number') {
          if (!this.hasSerials(this.codeRule)) {
            this.codeRule.push(this.createCodeRuleObj(t))
          } else {
            this.$toasted.show('只允许添加一个序列号字段')
          }
        } else {
          this.codeRule.push(this.createCodeRuleObj(t))
        }
      },
      delRow (idx) {
        this.codeRule.splice(idx, 1)
      },
      previewCode (arr) {
        let str = ''
        if (arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            let o = arr[i]
            let v = ''
            if (o.type == 'serial_number') {
              let vlu = (o.value > 20) ? 20 : o.value // 序列号不要超过20位
              v = this.createDigits(vlu)
            } else {
              v = o.value
            }
            str += v
          }
        }
        this.previewCodeStr = str
        return str
      },
      createDigits (len) {
        let str = ''
        while (len > 0) {
          if (len == 1) {
            str += '1'
          } else {
            str += '0'
          }
          len--
        }
        return str
      },
      setNum(arr) {
        let a = []
        arr.forEach(function(o, idx){
          o.num = idx
          a.push(o)
        })
        return a
      },
      createCodeRuleObj (t) {
        return {
          type: t,
          value: ''
        }
      },
      createCodeRule (arr) {
        let copied = clonedeep(arr)
        let serial_numbers = copied.filter((o) => {
          return o.type == 'serial_number'
        })
        serial_numbers.forEach((o) => {
          o.value = this.createDigits(o.value)
        })
        var s = this.setNum(copied.filter((o) => { return o.type == 'separator'}))
        var d = this.setNum(copied.filter((o) => { return o.type == 'date'}))
        var f = this.setNum(copied.filter((o) => { return o.type == 'fixed'}))
        var sr = this.setNum(copied.filter((o) => { return o.type == 'serial_number'}))
        var all = [s,d,f,sr].reduce((acc, cur)=>acc.concat(cur))
        all.forEach((o) => { // 设置start
          o.start = utils.findStrPos(this.previewCodeStr, o.value, o.num)
          delete o.num
        })
        // console.log('排序后', all)
        // console.log('排序前', copied)
        return this.sortTwoArr(copied, all)
      },
      sortTwoArr (arr1, arr2) {
        var resultArr = []
        for (let i = 0; i < arr1.length; i++) {
          let o = arr1[i]
          for (let j = 0; j < arr2.length; j++) {
            let o2 = arr2[j]
            if (o2.value == o.value && o2.start == o.start) {
              resultArr.push(o2)
            }
          }
        }
        return resultArr
      },
      getColor (item) {
        return 'rgba(' + item.rgba.r + ',' + item.rgba.g + ',' + item.rgba.b + ',' + item.rgba.a + ')'
      },
      setCertFont (arr1, arr2) {
        arr2.forEach((o) => {
          let idx = utils.findElem(arr1, 'pointKey', o.pointKey)
          if (idx > -1) {
            let obj = arr1[idx]
            obj.certFont = JSON.stringify({
              fontName: o.certFont.fontName,
              size: o.certFont.size,
              colorR: o.certFont.colors.rgba.r,
              colorG: o.certFont.colors.rgba.g,
              colorB: o.certFont.colors.rgba.b
            })
          }
        })
        return arr1
      },
      getCertFont (arr1, arr2) {
        arr1.forEach((o) => {
          this.$set(o,'certFont',{
            fontName: 'Microsoft YaHei',
            size: '18',
            colors: {
              rgba: {
                r: 0,
                g: 0,
                b: 0,
                a: 1
              }
            }
          })
        })
        arr2.forEach((o, index) => {
          let idx = utils.findElem(arr1, 'pointKey', o.pointKey)
          let obj = arr1[idx]
          if (idx > -1) {
            if (o.certFont) {
              let c = JSON.parse(o.certFont)
              obj.certFont = {
                fontName: c.fontName,
                size: c.size,
                colors: {
                  rgba: {
                    r: c.colorR,
                    g: c.colorG,
                    b: c.colorB,
                    a: 1
                  }
                }
              }
            }
          }
        })
        return arr1
      }
    }
  }
</script>

<style scoped>
  .drag {
    min-width: 40px;
    border-radius: 8px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    background: rgba(255,54,51,1);
    border: 1px solid white;
    position:  relative;
    color: #fff;
    display: inline-block;
    float: left;
    cursor: pointer;
    -moz-box-shadow: 3px 5px 15px #888; /* 老的 Firefox */
    box-shadow: 3px 5px 15px #888;
    z-index: 6;
  }
  .canvas {
    background: rgba(0,0,0,0.5);
    z-index: 3;
    vertical-align: top;
    opacity: 0;
  }
  .submitContainer {
    position: absolute;
    right: 25px;
    top: 25px;
  }
  .submitbox {
    width: 48px;
    height: 48px;
    line-height: 48px;
    border-radius: 50%;
    background: rgba(255,54,51,1);
    font-weight: 500;
    color: white;
    vertical-align: middle;
    /* background: url('../assets/images/submit_btn.png') no-repeat; */
    -moz-box-shadow: 3px 3px 5px #888; /* 老的 Firefox */
    box-shadow: 3px 3px 5px #888;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/cert/model.vue